import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { EventEmitter, Injectable, Output } from '@angular/core'
import { FormArray, FormBuilder, FormControl } from '@angular/forms'
import { catchError, throwError } from 'rxjs'
import { MatSnackBar } from '@angular/material/snack-bar'
import { Player } from '../../../core/models/player.model'
import { environment } from '../../../../environments/environment'
import { Metrics } from '../../../core/models/metrics.model' 
import { Match } from 'src/app/core/models/match.model'

export const METRICS_ARRAY: {
  field: string
  label: string
  category: '' | 'Remates' | 'Pases' | 'Ataque' | 'Defensa' | 'Otros'
}[] = [
  { field: 'matches', label: 'Partidos', category: 'Otros' },
  { field: 'minutes', label: 'Minutos', category: '' },
  { field: 'starter', label: 'Titular', category: 'Otros' },
  { field: 'goals.total', label: 'Goles', category: '' },
  { field: 'goals.inside_box', label: 'Goles dentro del área', category: 'Ataque' },
  { field: 'goals.conceded', label: 'Goles concedidos', category: 'Defensa' },
  { field: 'goals.prevented', label: 'Goles evitados', category: 'Defensa' },
  { field: 'assists', label: 'Asistencias', category: '' },
  { field: 'red_card', label: 'Tarjeta roja', category: 'Otros' },
  { field: 'yellow_cards', label: 'Tarjetas amarillas', category: 'Otros' },
  { field: 'own_goals', label: 'Goles en propia', category: 'Defensa' },
  { field: 'shots.total', label: 'Remates', category: 'Remates' },
  { field: 'shots.on_target', label: 'Remates a puerta', category: 'Remates' },
  { field: 'shots.conversion', label: '% efectividad en remates', category: 'Remates' },
  { field: 'shots.on_target_conversion', label: '% efectividad a puerta', category: 'Remates' },
  { field: 'xG', label: 'xG', category: 'Remates' },
  { field: 'xG_conversion', label: 'Goles - xG', category: 'Remates' },
  { field: 'xGOT', label: 'xGOT', category: 'Remates' },
  { field: 'touches.opp_half', label: 'Acciones en área rival', category: 'Ataque' },
  { field: 'touches.total', label: 'Acciones con balón', category: 'Pases' },
  { field: 'passes.accurate', label: 'Pases con éxito', category: 'Pases' },
  { field: 'passes.total', label: 'Pases', category: 'Pases' },
  { field: 'passes.accuracy', label: 'Acierto pase', category: 'Pases' },
  { field: 'passes.into_final_third', label: 'Pases en tercio rival', category: 'Pases' },
  { field: 'big_chances.missed', label: 'Grandes ocasiones falladas', category: 'Ataque' },
  { field: 'chances_created', label: 'Ocasiones creadas', category: 'Ataque' },
  { field: 'dribbles.successful', label: 'Regates con éxito', category: 'Ataque' },
  { field: 'dribbles.total', label: 'Regates', category: 'Ataque' },
  { field: 'dribbles.accuracy', label: '% Regates', category: 'Ataque' },
  { field: 'duels.total', label: 'Duelos', category: 'Defensa' },
  { field: 'duels.won', label: 'Duelos ganados', category: 'Defensa' },
  { field: 'duels.accuracy', label: '% Duelos', category: 'Defensa' },
  { field: 'aerials.total', label: 'Duelos aéreos', category: 'Defensa' },
  { field: 'aerials.won', label: 'Duelos aéreos ganados', category: 'Defensa' },
  { field: 'tackles', label: 'Robos', category: 'Defensa' },
  { field: 'recoveries', label: 'Recuperaciones', category: 'Defensa' },
  { field: 'clearances', label: 'Despejes', category: 'Defensa' },
  { field: 'interceptions', label: 'Intercepciones', category: 'Defensa' },
  { field: 'defensive_actions', label: 'Acciones defensivas', category: 'Defensa' },
  { field: 'offsides', label: 'Fueras de juego', category: 'Ataque' },
  { field: 'penalties.won', label: 'Penalties a favor', category: 'Ataque' },
  { field: 'penalties.conceded', label: 'Penalties en contra', category: 'Defensa' },
  { field: 'error_lead_to_goal', label: 'Error que lleva a gol', category: 'Defensa' },
  { field: 'saves.inside_box', label: 'Paradas dentro del área', category: 'Defensa' },
  { field: 'saves.total', label: 'Paradas totales', category: 'Defensa' },
  { field: 'fouls', label: 'Faltas', category: 'Otros' }
]

@Injectable({
  providedIn: 'root'
})
export class MetricsService {
  METRICS = METRICS_ARRAY

  constructor(
    private _snackBar: MatSnackBar, 
    private fb:FormBuilder, 
    private http: HttpClient) { 
      this.addArrayTeams()
    }

  readonly baseURL = environment.DOMAIN_URL+'/api/metrics/'

  @Output() filtersSubmittedEvent = new EventEmitter<null>()

  FiltersSubmitted(){
    this.filtersSubmittedEvent.emit()
  }

  filters = this.fb.group({
    season: ['2024/2025'],
    match: [''],
    team: [''],
    player: this.fb.control<Player[] | null>(null),
    starter: [''],
    competition: [''],
    minutes: this.fb.control<number | null>(null),
    fromDate: this.fb.control<Date | null>(null),
    toDate: this.fb.control<Date | null>(null),
    compute: true,
  })

  metricsForm = new FormControl('')
  metricsSelected: Metrics[] = [
      {label: 'Partidos', field:'matches' },
      {label: 'Goles', field:'goals.total' },
      {label: 'Asistencias', field:'assists' },
  ]
  playersSelected: Player[] = []
  playersForm = new FormControl('')

  matchForm = this.fb.group({
    match: this.fb.control<Match | null>(null),
    arbitro: [''],
    teams: this.fb.array([])
  })

  get teams(): FormArray {
    return this.matchForm.get('teams') as FormArray
  }
  
  addArrayTeams(){
    for (let i = 0; i < 2; i++) {
      this.teams.push(this.fb.group({
        coach: [''],
        yellow_cards: this.fb.control<number | null>(null),
        red_cards: this.fb.control<number | null>(null),
        goals: this.fb.array([])
      }))
    }
  }

  get goals(): FormArray {
    return this.teams.get('goals') as FormArray
  }
  
  addArrayGoals(){
    for (let i = 0; i < 2; i++) {
      this.teams.push(this.fb.group({
        minute: this.fb.control<number | null>(null),
        type: [''],
      }))
    }
  }
  
  fetchFilteredMetrics(){
    const filters = this.filters.getRawValue()
    filters.player = this.playersSelected
    return this.http.post(this.baseURL+'filters',filters)
    .pipe(catchError(this.errorHandler))
  }

  fetchMetrics(data:any){
    return this.http.post(this.baseURL+'detail',data)
    .pipe(catchError(this.errorHandler))
  }

  private errorHandler(error: HttpErrorResponse) {
    if (error.status === 0) console.error('An error occurred:', error.error)
    else console.error(`Backend returned code ${error.status}, body was: `, error.error)
    return throwError(() => new Error('Something bad happened; please try again later.'))
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, 'Close',{
      duration: 3000,
      verticalPosition: 'bottom',
    })
  }
}